<template>
  <div class="ml-3">
    <v-card class="pa-0">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              v-bind:label="$t('File')"
              v-model="filter.Type"
              :items="typeList"
              item-text="text"
              item-value="id"
              @change="updateGrid"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              v-bind:label="$t('Type')"
              v-model="filter.Level"
              :items="levelList"
              item-text="text"
              item-value="id"
              @change="updateGrid"
              clearable
            ></v-select>
          </v-col>
          <v-col>
            <BaseDatePicker
              v-model="filter.From"
              :label="$t('From')"
              clearable
              @change="updateGrid"
            />
          </v-col>
          <v-col>
            <BaseDatePicker
              v-model="filter.To"
              :label="$t('To')"
              clearable
              @change="updateGrid"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="pa-0 mt-0" :loading="loading">
      <v-card-text class="pt-0 mt-0">
        <dx-data-grid
          :ref="grid.key"
          :data-source="grid.dataSource"
          :remote-operations="false"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :columns-auto-width="true"
          :word-wrap-enable="true"
          :row-alternation-enabled="true"
          :show-column-lines="true"
          :show-row-lines="true"
          :show-borders="true"
        >
          <dx-filter-row :visible="true" />
          <dx-header-filter :visible="true" />
          <dx-search-panel :visible="true" :highlight-case-sensitive="true" />
          <dx-pager
            :allowed-page-sizes="[5, 10, 15, 20]"
            :show-page-size-selector="true"
          />
          <dx-paging :page-size="15" />

          <dx-column
            width="10%"
            data-field="Date"
            :caption="this.$t('Date')"
            data-type="date"
            format="dd-MM-yyyy HH:mm:ss"
            alignment="center"
          />
          <dx-column
            width="10%"
            data-field="Level"
            :caption="this.$t('Type')"
            alignment="center"
            cell-template="cellTemplate"
          />
          <dx-column
            data-field="Log"
            :caption="this.$t('Log')"
            data-type="string"
            alignment="center"
          />

          <template #cellTemplate="{ data }">
            <span
              :class="{
                'blue--text': data.value == 0,
                'orange--text': data.value == 1,
                'red--text': data.value == 2,
              }"
              >{{
                data.value == 0 ? "INFO" : data.value == 1 ? "WARNING" : "ERROR"
              }}</span
            >
          </template>
        </dx-data-grid>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ParameterService from "@/services/ParameterService";
import Utils from "@/ecm/common/Utils";

import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxSearchPanel,
  DxFilterRow,
  DxHeaderFilter,
  DxExport,
} from "devextreme-vue/data-grid";

import * as frMessages from "devextreme/localization/messages/fr.json";
import * as deMessages from "devextreme/localization/messages/de.json";
import * as itMessages from "devextreme/localization/messages/it.json";
import * as ptMessages from "devextreme/localization/messages/pt.json";
import * as ruMessages from "devextreme/localization/messages/ru.json";
import * as esMessages from "devextreme/localization/messages/es.json";

import { locale, loadMessages } from "devextreme/localization";

export default {
  components: {
    //dx
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxFilterRow,
    DxHeaderFilter,
    DxExport,
  },
  created() {
    var currentCulture = this.$store.getters["account/user"].CultureCode;
    switch (currentCulture) {
      case "fr":
        loadMessages(frMessages.default);
        break;
      case "de":
        loadMessages(deMessages.default);
        break;
      case "it":
        loadMessages(itMessages.default);
        break;
      case "pt":
        loadMessages(ptMessages.default);
        break;
      case "ru":
        loadMessages(ruMessages.default);
        break;
      case "es":
        loadMessages(esMessages.default);
        break;
    }

    locale(currentCulture);
  },
  data() {
    return {
      title: this.$t("Logs"),
      typeList: [
        { id: "Doc.ECM", text: this.$t("Doc ECM") },
        { id: "AlertsJobs", text: this.$t("Alerts") },
        {
          id: "DataManagementJobs",
          text: this.$t("DataManagement"),
        },
        {
          id: "DocumentLifecycleJobs",
          text: this.$t("DocumentLifecycle"),
        },
        { id: "DelegationsJobs", text: `${this.$t("Delegations")} (Jobs)` },
        {
          id: "DelegationsError",
          text: `${this.$t("Delegations")} (${this.$t("Errors")})`,
        },
        { id: "LicenceJobs", text: this.$t("Licence") },
        { id: "Jobs", text: "Jobs" },
        {
          id: "ObjectsPreAuthorization",
          text: this.$t("AutomaticAuthorization"),
        },
        { id: "Plugins", text: this.$t("Plugins") },
        { id: "Sync", text: this.$t("ConnectedServices") },
        { id: "AutoImportJobs", text: this.$t("AutoImport") },
      ],
      levelList: [
        { id: "0", text: this.$t("INFO") },
        { id: "1", text: this.$t("WARNING") },
        { id: "2", text: this.$t("ERROR") },
      ],
      filter: {
        Type: "Doc.ECM",
        From: "",
        To: "",
        Level: "",
      },
      loading: false,
      grid: {
        key: "logGrid",
        dataSource: [],
      },
    };
  },
  mounted() {
    this.updateGrid();
  },
  methods: {
    updateGrid() {
      this.loading = true;
      ParameterService.getLog(Utils.object.toJS(this.filter)).then((res) => {
        this.grid.dataSource = res;
        this.loading = false;
      });
    },
  },
};
</script>
